export const checkIfServerSideRendering = () => typeof window === 'undefined';
